export default __webpack_public_path__ + "static/media/our-culture-mobile-bg.a43ccbce.svg";